import React from 'react';
import AuthenticatedPage from "../../ContextAndHOC/AuthenticatedPage";
import { withStyles, Button, withWidth } from '@material-ui/core';
import ErrorDialogsuccess from '../../components/ErrorDialog';
import SuccessDialog from '../../components/SuccessDialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import CommonDashboard from '../../components/CommonDashBord';
import JsonPreview from './AFBPreview';
import {StatusCodes} from 'http-status-codes';
import Title from '../../components/CommonDashboardTitle';
import {buildData, handleError} from "../../components/DeleteRecurring";
const styles = theme => ({
    root: {marginTop: theme.spacing(3),...theme.mixins.gutters(),paddingTop: theme.spacing(1),paddingBottom: theme.spacing(1),},
    primaryBtn: { color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main, border: `1px solid ${theme.palette.border.primaryBorder}`, borderRadius: "50px", margin: "8px 0", textAlign: "right",
    padding: "7px 20px", textTransform: "uppercase", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main, color: theme.palette.text.hoverTextPrimaryColor, border: `1px solid ${theme.palette.border.hoverPrimaryBorder}`} },
    loadingBody:{minHeight:'100vh'},
    tableStyle:{maxWidth:'1200px', margin:'auto'}
});

class AFBList extends React.Component {
    state = {
        AFBdata:[] ,
        inactivate: false,
        TotalAFB: '',
        loading: true,
        AFBListCount: 0,
        // deleteTriviaId:'',
        reqAttentionCount:0,
        reqAttentionFilter:"1",
        Open:false,
        id:0,
        load:false,
        openpopup:false,
        previewopen:true,
        values:{},
        dialogueLoad: false,
        deleteDialogStatus:false,
        deleteMessage:"",
        version:null
    };
   handleClose = () => {
     this.setState({openpopup:false,previewopen:false});
    };
    handleAFBEditUser = (resourceid,variant,version, clone,newversion_clone) => {
    const selectedarticle = this.state.AFBdata.filter((n) =>n.resourceid === resourceid);
    const Afbversionedit=selectedarticle.filter((n) =>n.versionNumber === version);
    if(!clone){
      this.props.history.push({
          pathname: `./AFB/Edit/${resourceid}/${variant}`,
          clone,newversion_clone,
          state: { detail:Afbversionedit }
        });
  } else {
      this.props.history.push({
          pathname: `./AFB/Edit/Clone/${resourceid}/${variant}`,
          clone,newversion_clone,
          state: { detail:Afbversionedit }
        });
  }
    };
    handleAFBdeletepopup = (resourceid, version) => {
      this.setState({ Open: true, id: resourceid, version });
    };
  handleDeleteUserAFB = async () => {
    this.setState({dialogueLoad:true, Open:false})
    let response = await this.props.authenticatedApiCall('post', '/api/content/contentservice/deleteAFBResource', buildData(this.state.AFBdata, this.state.id, this.state.version));
    this.setState({dialogueLoad:false, deleteDialogStatus:true})
    const ErrorMsg = handleError(response);
    this.setState({deleteMessage: ErrorMsg});
  };
 handleCloseDialogAFB = () => {
     this.setState({Open:false});
  };
  handleData = (response) => {
    this.setState({ AFBdata: response.data.data });
  };
    async componentDidMount() {
        this.setState({load:true});
        let response = await this.props.authenticatedApiCall('get', '/api/content/contentservice/getAFBResource', null);
        this.setState({load:false});
        if (response && response.status === StatusCodes.OK) {
               this.handleData(response);
        } else {
            this.setState({AFBdata: []});
        }
    }
  handleAFBpreview = (resourceid,version) => {
    const selectedafb = this.state.AFBdata.filter((n) => n.resourceid === resourceid);
    const Afbpreviewdata=selectedafb.filter((n) =>n.versionNumber === version);
    this.setState({ values:Afbpreviewdata[0], openpopup: true, previewopen: true });
  };
   handleAddNewAFB = () => {
      this.props.history.push("./AFB/New");
    };
    handleDeleteDialogClose = () => {
      this.props.history.go(0);
    }
    render() {
        const { classes} = this.props;
          const okbutton = [
      <Button className={classes.primaryBtn} onClick={this.handleCloseDialogAFB} >No</Button>,
      <Button className={classes.primaryBtn} onClick={this.handleDeleteUserAFB}>Yes</Button>
    ];
    const deleteDialogButton = [ <Button className={classes.primaryBtn} onClick={this.handleDeleteDialogClose}>Close</Button> ];
    const errorMessage = "Are you sure you want to delete this AFB?";
        return (
            <div>
                <div className={classes.tableStyle}>
                 <Title titlename={"AFB"} count={this.state.AFBdata.length}  button3={this.handleAddNewAFB}/>
                    {this.state.load && <div className={classes.loadingBody}>
                      <CircularProgress color="primary" style={{position: "absolute",left: "50%",top:"50%"}}/></div>}
                  {this.state.AFBdata && this.state.AFBdata.length>0?
                  <CommonDashboard  patientList = {this.state.AFBdata} reqAttentionFilter={this.state.reqAttentionFilter}
                  handleEditUser={this.handleAFBEditUser}  handleDeleteUser={this.handleAFBdeletepopup}  handleAddNewPatient={this.handleAddNewAFB} name={"afb"} handlepreview={this.handleAFBpreview} />:""}
                </div>
                {this.state.Open? <ErrorDialogsuccess successButton={okbutton}  HeaderText={errorMessage}  dismiss={this.handleCloseDialogAFB}/>:""}
                {this.state.deleteDialogStatus && <SuccessDialog successButton={deleteDialogButton} HeaderText={"Success"} BodyText={this.state.deleteMessage}  dismiss={this.handleDeleteDialogClose}/>}
                {this.state.dialogueLoad && <div className={classes.loadingBody}> <CircularProgress color="primary" style={{position: "absolute",left: "50%",top:"75%"}}/></div>}
                  {this.state.openpopup ? (<JsonPreview open={this.state.previewopen} handleClose={this.handleClose} list={this.state.values} />) : ( "" )}
            </div>
        );
    }
}

export default withWidth()((withStyles(styles)(AuthenticatedPage()(AFBList))));